var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3167 5.80833L14.1917 2.68333C14.075 2.56667 13.9167 2.5 13.75 2.5H3.75C3.05833 2.5 2.5 3.05833 2.5 3.75V16.25C2.5 16.9417 3.05833 17.5 3.75 17.5H16.25C16.9417 17.5 17.5 16.9417 17.5 16.25V6.25C17.5 6.08333 17.4333 5.925 17.3167 5.80833ZM7.5 3.75H12.5V6.25H7.5V3.75ZM12.5 16.25H7.5V11.25H12.5V16.25ZM13.75 16.25V11.25C13.75 10.5583 13.1917 10 12.5 10H7.5C6.80833 10 6.25 10.5583 6.25 11.25V16.25H3.75V3.75H6.25V6.25C6.25 6.94167 6.80833 7.5 7.5 7.5H12.5C13.1917 7.5 13.75 6.94167 13.75 6.25V4.00833L16.25 6.50833V16.25H13.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSave);
export default __webpack_public_path__ + "static/media/ic-save.0daf1570ed971704b82a03e7f34bb5d5.svg";
export { ForwardRef as ReactComponent };